import type { BaseTokenIconProps } from "@stepfinance/react";
import { BaseTokenIcon } from "@stepfinance/react";
import type { FC } from "react";

import { getTokenIcon } from "../../utils/tokenInfo";
import RedirectLink from "../RedirectLink/RedirectLink";
import { TokenIconText } from "../shared";

export type TokenIconProps = Omit<BaseTokenIconProps, "getTokenIcon">;

/**
 * The colorful logo of a Token, e.g. Classic Orange BTC Symbol. This wrapper simply needs a mintAddress to work
 * @param mintAddress of the Token
 * @param size optional size override
 * @param props extra props for BaseTokenIcon
 * @constructor
 */
export const TokenIcon: FC<TokenIconProps> = (props) => {
  return <BaseTokenIcon getTokenIcon={getTokenIcon} {...props} />;
};

type OneOrTwoTokenIconsProps = {
  tokenAMint: string;
  tokenBMint?: string;
  url: string;
  name: string;
};

export const OneOrTwoTokenIcons: FC<OneOrTwoTokenIconsProps> = ({ tokenAMint, tokenBMint, url, name }) => {
  return (
    <>
      <TokenIcon mintAddress={tokenBMint ? [tokenAMint, tokenBMint] : tokenAMint} />
      <TokenIconText>{url ? <RedirectLink href={url}>{name}</RedirectLink> : name}</TokenIconText>
    </>
  );
};
